import getAxiosInstance from "@/api/get-axios-instance"

const getUploadEndpoint = () => process.env.VUE_APP_API_BASE + `/images`
const fetchImages = async () => getAxiosInstance().get("images")
const imageAPI = {
  getUploadEndpoint,
  fetchImages
}
export default imageAPI
